const ProductsPage = () => {
  return <section className=""></section>;
};

export default ProductsPage;
